export default __webpack_public_path__ + "static/media/EP10_ERYTHREE.115a57de.mp3";